import { Component, EventEmitter, OnInit, Output, HostListener, ElementRef , ViewChild, TemplateRef} from '@angular/core';
import {NgbModal, ModalDismissReasons}   from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {HttpClient,HttpClientModule,HttpHeaders,} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApidataService } from '../apidata.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import html2canvas from "html2canvas";
import jspdf from "jspdf";
import { FormBuilder, NgForm } from "@angular/forms";
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';

@Component({
  selector: 'app-compose-email',
  standalone: true,
  imports: [NgbDatepickerModule, HttpClientModule,CommonModule,
    ReactiveFormsModule,
    FormsModule,IconsFreeToolsComponent
   ],
  templateUrl: './compose-email.component.html',
  styleUrl: './compose-email.component.css'
})
export class ComposeEmailComponent {
  closeResult = '';
  email_to;
  newlastWord;
  email_cc;
  email_sub;
  email_body;
  esubText2;
  color: string = "black";
  esubText4;
  saveFileText4: string = "";
  esubText: string = "";
  emailAddress = "";
   pdfdone: boolean = false;
  docxdone: boolean = false;
  model: any = {};
  profile_id = "";
  doc_id = "";
  lastName = "";
  firstName = "";
  comefromgrammarin;
  dictionaryStatus = "";
  comefromsite: boolean = false;
  yesturedic: boolean = true;
  editorState = {
    doc_id: this.router.url.split('/').pop(),
  }

  constructor(private modalService: NgbModal,
    private router: Router,
    private apiservice: ApidataService,
     private http:HttpClient ,
    private elementRef: ElementRef, private route: ActivatedRoute,) {}
  @ViewChild('content', { static: true }) content: TemplateRef<any>;

  ngOnInit() {
    this.openModal();
    this.fetchProfileData();
    this.route.queryParams.subscribe((params) => {
      const docId = params['doc'];
      if (docId) {
        this.editorState.doc_id = docId;
      }
    });
  }
  public ngAfterViewInit(): void {
    this.fetchProfileData();
  }
  openModal() {
    this.modalService.open(this.content,{ backdrop: 'static', keyboard: false , centered: true,windowClass: 'my-class'});
  }

  openModels(content:any, data:any=null){
    this.modalService.open(content,{size:"lg"})

    }
    closeModal(){
      this.modalService.dismissAll();
    }

  clearemail() {
    this.email_cc = $("#email_cc").val("");
    this.email_sub = $("#email_sub").val("");
    this.email_body = $("#email_body").val("");
    this.isTooltipVisible = false;

  }
   captureScreen(done) {
      this.pdfdone = true;
      this.docxdone = false;
      this.model.attachpdf = done;
      var data = document.getElementById("mm");
      html2canvas(data).then((canvas) => {
        var imgWidth = 208;
        var pageHeight = 295;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;

        const contentDataURL = canvas.toDataURL("pdf");
        let pdf = new jspdf("p", "mm", "a4");
        var position = 0;
        pdf.addImage(contentDataURL, "pdf", 0, position, imgWidth, imgHeight);
      });
    }

   captureScreenfordoc(docx) {
      this.docxdone = true;
      this.pdfdone = false;
      this.model.attachdocx = docx;
      var data = document.getElementById("mm");
    }

    public eSubmission(f: NgForm) {
      var check = $('#mm').html()
      if (check === " ") {
        this.color = "red";
        this.esubText4 = "Please type first on the editor. ";
        $("#esubText").show();
        setTimeout(function () {
          $("#esubText").hide();
        }, 4000);
      }
  
      if (!this.pdfdone && !this.docxdone) {
        this.color = "red";
        this.esubText = "Please attach pdf or docx file with required fields";
        $("#esubText").show();
        setTimeout(function () {
          $("#esubText").hide();
        }, 4000);
      }
  
      if (this.pdfdone) {
        this.model.attachpdf = "pdf";
        this.email_sub = $("#email_sub").val();
        this.email_body = $("#email_body").val();
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  
        if (this.email_sub === "" || this.email_body === "") {
          this.color = "red";
          this.esubText = "Please provide the required fields";
        } else {
          this.profile_id = localStorage.getItem("profile_id");
  
          this.apiservice
            .submitEDocument(
              this.profile_id,
              this.editorState.doc_id,
              this.email_sub,
              this.email_body,
              this.model.attachpdf
            )
            .subscribe(
              (data) => this.handleESubmit(data),
              (err) => this.logError(err)
            );
        }
      } else if (this.docxdone) {
        this.model.attachdocx = "docx";
        this.email_sub = $("#email_sub").val();
        this.email_body = $("#email_body").val();
  
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  
        if (this.email_sub === "" || this.email_body === "") {
          this.color = "red";
          this.esubText = "Please provide the required fields";
          $("#esubText").show();
          setTimeout(function () {
            $("#esubText").hide();
          }, 3000);
        } else {
          this.profile_id = localStorage.getItem("profile_id");
     
  
          this.apiservice
            .submitEDocument(
              this.profile_id,
              this.editorState.doc_id,
              this.email_sub,
              this.email_body,
              this.model.attachdocx
            )
            .subscribe(
              (data) => this.handleESubmit(data),
              (err) => this.logError(err)
  
            );
          // f.resetForm();
        
        }
  
      }
  
    }
    handleESubmit(data: Response) {
    
        this.color = "green";
        this.esubText2 = "Email Sent Successfully!";
        $("#esubText2").show();
        setTimeout(function () {
          $("#esubText2").hide();
        }, 3000);
      // }
      // $("#email_to").val("");
      $("#email_cc").val("");
      $("#email_sub").val("");
      $("#email_body").val("");
      this.isTooltipVisible = false;
      
    }

  private logError(err: Response) {
    let receivedData = err;
    if (err.status === 0) {
    }
    if (err.status === 401) {

    }
  }
 fetchProfileData() {
 
    this.profile_id = localStorage.getItem("profile_id");
    this.apiservice
      .getUserProfileContents(this.profile_id)
      .subscribe((data) => this.LoadProfileData(data));
  }
  public LoadProfileData(data: Response) {

      let receivedData = data;
      this.firstName = receivedData["contents"][0][1];
      this.lastName = receivedData["contents"][0][2];
      this.emailAddress = receivedData["contents"][0][0];
      this.dictionaryStatus = receivedData["contents"][0][3];
      this.comefromgrammarin = receivedData["contents"][0][4];
      if (this.comefromgrammarin === "grammarin") {
        this.comefromsite = true;
      }
      if (this.dictionaryStatus == 'off'){
        this.yesturedic = false;
      }
   
  }
  isTooltipVisible = false; 
  showAcademic: boolean = false;
  formality: string = 'formal'; 
  intent: string = 'inform';

  toggleTooltip() {
    this.isTooltipVisible = !this.isTooltipVisible;
  }
      // compose email end
}
